module.exports = __webpack_public_path__ + "media/images/multi-images-8b328f1c60580e0497806fe9b61346f7.svg";